import Component from '@glimmer/component';
import { service } from '@ember/service';
import { eq } from '../../helpers/article-type';
import type TwitchEmbedService from '../../services/twitch-embed';

export default class StreamPreviewComponent extends Component {
  @service declare twitchEmbed: TwitchEmbedService;

  get embedHtml() {
    const channel = this.args.stream?.userName;
    if (!channel) return '';
    
    return this.twitchEmbed.getChannelIframeHtml(channel, {
      width: '100%',
      height: '180',
      autoplay: false,
      muted: true,
    });
  }

  <template>
    <div class='stream-preview'>
      <div class='stream-preview-streamer stream-preview-streamer-1'>
        <div class='stream-preview-name-line'>
          <p class='stream-preview-streamer-name'>{{@stream.userDisplayName}}</p>
          <p class='stream-start-counter live'>Live</p>
        </div>
        <p class='stream-preview-streamer-topic'>{{@stream.title}}</p>
      </div>
      <div class='widget-media small'>
        {{{this.embedHtml}}}
      </div>
    </div>
  </template>
}
